export interface Extents {
  latitude: number,
  longitude: number,
  zoom: number,
  searchZoom?: number,
  initialZoom?: number,
  maxZoom?: number,
}

export interface Point {
  lat: () => number,
  lng: () => number,
}

export interface Bounds {
  getSouthWest: () => Point,
  getNorthEast: () => Point,
}

export const defaultExtents: Extents = {
  latitude: 0,
  longitude: 0,
  zoom: 2,
  searchZoom: 12,
  initialZoom: 2.5,
  maxZoom: 18,
};

export interface LatLng {
  lat: number,
  lng: number
}

export interface Coordinate {
  latitude: number,
  longitude: number
}

export type LngLatCoordinate = [number, number]

// @deprecated Use LngLatCoordinate instead
export type LatLngCoordinate = [number, number]

export type GeometricType = 'Point' | 'LineString' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon';
export type CoordinateTypes = LngLatCoordinate | LngLatCoordinate[] | LngLatCoordinate[][] | LngLatCoordinate[][][]
export interface GeometricShape {
  type: GeometricType;
  coordinates: CoordinateTypes;
  item?: Record<string, any>;
}
